import type { GetSignedMapUrlApiCall } from 'Pages/api/utils/static-map/request';
import { resolveParams } from 'Services/services.helpers';

import axios from '../axios';

export const getStaticMapUrl: GetSignedMapUrlApiCall = async (query) => {
	const res = await axios.get(`/api/utils/static-map${resolveParams(query)}`);
	return res.data;
};
